<template>
    <div class="contact-area-modern " >
        <!-- Success/Error Message -->
        <div v-if="successMessage || failMessage" 
             class="message-toast" 
             :class="{'success': successMessage, 'error': failMessage}"
             @click="closeMessage">
            <div class="message-content">
                <i :class="successMessage ? 'ri-check-line' : 'ri-error-warning-line'"></i>
                <span>{{ successMessage || failMessage }}</span>
                <button class="close-btn">&times;</button>
            </div>
        </div>

        <!-- Main Contact Section -->
        <div class="contact-section ptb-100 wave-bg">
            <div class="container">
                <!-- Section Header -->
                <div class="simple-header text-center" data-aos="fade-up">
                    <span class="sub-title">#Connect With Us</span>
                    <h1 class="hero-main-title">Contact <span class="gradient-text">Us</span></h1>
                    <p class="hero-description">
                        Ready to transform your business? Let's discuss your project and create 
                        something amazing together. Our experts are here to help you succeed.
                    </p>
                            </div>

                <!-- Contact Form Container -->
                <div class="contact-form-container" data-aos="fade-up" data-aos-delay="200">
                    <div class="form-wrapper">
                        <!-- Decorative Elements -->
                        <div class="form-decoration">
                            <div class="floating-shape shape-1"></div>
                            <div class="floating-shape shape-2"></div>
                            <div class="floating-shape shape-3"></div>
                        </div>

                        <form @submit.prevent="submitForm" class="modern-contact-form">
                            <div class="form-grid">
                                <!-- Name Field -->
                                <div class="form-group" data-aos="fade-up" data-aos-delay="300">
                                    <div class="input-wrapper">
                                        <input 
                                            v-model="formData.name" 
                                            required 
                                            type="text" 
                                            id="name"
                                            class="form-input"
                                            placeholder=" "
                                        >
                                        <label for="name" class="form-label">Full Name</label>
                                        <div class="input-border"></div>
                            </div>
                        </div>

                                <!-- Email Field -->
                                <div class="form-group" data-aos="fade-up" data-aos-delay="350">
                                    <div class="input-wrapper">
                                        <input 
                                            v-model="formData.email" 
                                            required 
                                            type="email" 
                                            id="email"
                                            class="form-input"
                                            placeholder=" "
                                        >
                                        <label for="email" class="form-label">Email Address</label>
                                        <div class="input-border"></div>
                            </div>
                        </div>

                                <!-- Phone Field -->
                                <div class="form-group" data-aos="fade-up" data-aos-delay="400">
                                    <div class="input-wrapper">
                                        <input 
                                            v-model="formData.phone" 
                                            required 
                                            type="tel" 
                                            id="phone"
                                            class="form-input"
                                            placeholder=" "
                                        >
                                        <label for="phone" class="form-label">Phone Number</label>
                                        <div class="input-border"></div>
                            </div>
                        </div>

                                <!-- Subject Field -->
                                <div class="form-group" data-aos="fade-up" data-aos-delay="450">
                                    <div class="input-wrapper">
                                        <input 
                                            v-model="formData.admin_notes" 
                                            required 
                                            type="text" 
                                            id="subject"
                                            class="form-input"
                                            placeholder=" "
                                        >
                                        <label for="subject" class="form-label">Subject</label>
                                        <div class="input-border"></div>
                            </div>
                        </div> 

                                <!-- Message Field -->
                                <div class="form-group full-width" data-aos="fade-up" data-aos-delay="500">
                                    <div class="input-wrapper textarea-wrapper">
                                        <textarea 
                                            v-model="formData.notes" 
                                            required 
                                            id="message"
                                            class="form-input form-textarea"
                                            rows="6"
                                            placeholder=" "
                                        ></textarea>
                                        <label for="message" class="form-label">Your Message</label>
                                        <div class="input-border"></div>
                                    </div>
                                </div>

                                <!-- reCAPTCHA -->
                                <div class="form-group full-width recaptcha-container" >
  <recaptcha></recaptcha>
 </div>

                                <!-- Submit Button -->
                                <div class="form-group full-width">
                                    <button type="submit" class="submit-btn" :disabled="isSubmitting">
                                        <span v-if="!isSubmitting" class="btn-content">
                                            <i class="ri-send-plane-line"></i>
                                            Send Message
                                        </span>
                                        <span v-else class="btn-content loading">
                                            <i class="ri-loader-4-line spinning"></i>
                                            Sending...
                                        </span>
                                    </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
            </div>

            <!-- Background Elements -->
            <div class="background-elements">
                <div class="gradient-orb orb-1"></div>
                <div class="gradient-orb orb-2"></div>
                <div class="gradient-orb orb-3"></div>
                <div class="mesh-grid"></div>
            </div>
        </div>

        <!-- Map Section -->
        <div class="map-section" data-aos="fade-up">
            <div class="map-container">
                <iframe 
                    src="https://www.google.com/maps?q=Tdi+Business+Centre%2C+18+-+11th%2C+VR+Punjab+Mall+Rd%2C+Sector+118%2C+Sahibzada+Ajit+Singh+Nagar%2C+Punjab+160055&output=embed"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade">
                </iframe>
                <div class="map-overlay">
                    <div class="location-info">
                        <h3>Visit Our Office</h3>
                        <p>TDI Business Centre, Sector 118<br>Sahibzada Ajit Singh Nagar, Punjab</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Modern Contact Area Styles */
.contact-area-modern {
    position: relative;
    overflow: hidden;
    width: 100%;
    max-width: 100vw;
}

.contact-area-modern *,
.contact-area-modern *::before,
.contact-area-modern *::after {
    box-sizing: border-box;
}

/* Message Toast */
.message-toast {
    position: fixed;
    top: 80px;
    right: 20px;
    z-index: 1000;
    padding: 0;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    transform: translateX(400px);
    animation: slideIn 0.5s ease-out forwards;
    max-width: 400px;
    backdrop-filter: blur(10px);
}

.message-toast.success {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.9) 0%, rgba(21, 128, 61, 0.9) 100%);
}

.message-toast.error {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.9) 0%, rgba(185, 28, 28, 0.9) 100%);
}

.message-content {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    color: white;
    font-weight: 500;
}

.message-content i {
    font-size: 20px;
    margin-right: 12px;
    flex-shrink: 0;
}

.close-btn {
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    margin-left: auto;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.3s ease;
}

.close-btn:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

/* Contact Section */
.contact-section {
    position: relative;
   background: linear-gradient(279.99deg, #9F5FF196 -1.19%, #FF54B042 50.99%, #FF9F5A69 100%);
    min-height: 100vh;
    display: flex;
    align-items: center;
    width: 100%;
    overflow-x: hidden;
}

/* Hero Header */
.hero-header {
    text-align: center;
    margin-bottom: 80px;
    position: relative;
    padding: 60px 0;
}

.header-content {
    position: relative;
    z-index: 2;
}

.header-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50px;
    padding: 12px 24px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    font-weight: 500;
    animation: pulse 2s ease-in-out infinite;
}

.header-badge i {
    color: #ED2775;
    font-size: 16px;
}

.hero-title {
    font-size: 4rem;
    font-weight: 900;
    color: #ffffff;
    margin-bottom: 24px;
    line-height: 1.1;
    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

/* .gradient-text {
    background: linear-gradient(135deg, #ED2775 0%, #FF7448 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
    text-shadow: none;
} */

/* .gradient-text::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(135deg, #ff6b35 0%, #f7941d 100%);
    border-radius: 2px;
    opacity: 0.7;
} */

.hero-description {
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.8);
    max-width: 700px;
    margin: 0 auto 50px;
    line-height: 1.6;
}

/* Simple Header */
.simple-header {
    position: relative;
    padding: 40px 0;
}

.sub-title {
    color: rgba(255, 255, 255, 0.8);
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 15px;
    display: block;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.hero-main-title {
    font-size: 40px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 10px;
    line-height: 1.1;
    text-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
}

.hero-description {
    font-size: 1.3rem;
    color: rgba(255, 255, 255, 0.9);
    max-width: 700px;
    margin: 0 auto;
    line-height: 1.7;
    font-weight: 400;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* Contact Stats */
.contact-stats {
    display: flex;
    justify-content: center;
    gap: 60px;
    margin-top: 50px;
}

.stat-item {
    text-align: center;
}

.stat-number {
    font-size: 2.5rem;
    font-weight: 900;
    color: #ffffff;
    margin-bottom: 8px;
    background: linear-gradient(135deg, #ED2775 0%, #FF7448 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.stat-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600;
}

/* Header Decorations */
.header-decorations {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
}

.floating-icon {
    position: absolute;
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.7);
    font-size: 24px;
    animation: floatIcon 6s ease-in-out infinite;
}

.icon-1 {
    top: 20%;
    left: 10%;
    animation-delay: 0s;
}

.icon-2 {
    top: 30%;
    right: 15%;
    animation-delay: 1.5s;
}

.icon-3 {
    bottom: 40%;
    left: 8%;
    animation-delay: 3s;
}

.icon-4 {
    bottom: 20%;
    right: 12%;
    animation-delay: 4.5s;
}

/* Form Container */
.contact-form-container {
    max-width: 700px;
    margin: 0 auto;
    position: relative;
    width: 100%;
    box-sizing: border-box;
}

/* Mobile keyboard accommodation */
@media (max-width: 768px) {
    .contact-form-container {
        min-height: auto;
        margin-bottom: 20px;
    }
    
    .modern-contact-form {
        padding-bottom: 20px;
    }
}

.form-wrapper {
    background: #fff;
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 24px;
    padding: 40px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
}

/* Form Decoration */
.form-decoration {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
}

.floating-shape {
    position: absolute;
    border-radius: 50%;
    opacity: 0.1;
    animation: floatAnimation 6s ease-in-out infinite;
}

.shape-1 {
    width: 100px;
    height: 100px;
    background: linear-gradient(135deg, #ED2775, #FF7448);
    top: 20px;
    right: 20px;
    animation-delay: 0s;
}

.shape-2 {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #60a5fa, #a78bfa);
    bottom: 40px;
    left: 40px;
    animation-delay: 2s;
}

.shape-3 {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #f472b6, #a855f7);
    top: 50%;
    left: 20px;
    animation-delay: 4s;
}

/* Modern Contact Form */
.modern-contact-form {
    width: 100%;
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
}

/* Ensure all form elements use border-box */
.modern-contact-form *,
.modern-contact-form *::before,
.modern-contact-form *::after {
    box-sizing: border-box;
}

/* Form Grid */
.form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
}

.form-group.full-width {
    grid-column: 1 / -1;
}

/* Input Styling */
.input-wrapper {
    position: relative;
}

.form-input {
    width: 100%;
    padding: 20px 0 8px 0;
    background: transparent;
    border: none;
    outline: none;
    color: #101720;
    font-size: 16px;
    border-bottom: 2px solid #101720;
    transition: all 0.3s ease;
}

.form-input:focus,
.form-input:not(:placeholder-shown) {
    border-bottom-color: #ED2775;
}

.form-label {
    position: absolute;
    top: 20px;
    left: 0;
    color: #101720;
    font-size: 16px;
    pointer-events: none;
    transition: all 0.3s ease;
    transform-origin: left top;
}

.form-input:focus + .form-label,
.form-input:not(:placeholder-shown) + .form-label {
    transform: translateY(-20px) scale(0.85);
    color: #ED2775;
}
/* 
.input-border {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: linear-gradient(135deg, #ED2775 0%, #FF7448 100%);
    transition: width 0.3s ease;
} */

.form-input:focus ~ .input-border {
    width: 100%;
}

/* Textarea Specific */
.form-textarea {
    resize: vertical;
    min-height: 120px;
    padding-top: 20px;
}

.textarea-wrapper .form-label {
    top: 20px;
}

/* reCAPTCHA Container */
.recaptcha-container {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

/* Mobile-specific improvements */
@media (hover: none) and (pointer: coarse) {
    /* Touch device specific styles */
    .modern-contact-form {
        touch-action: manipulation;
    }
    
    .submit-btn {
        -webkit-tap-highlight-color: transparent;
        touch-action: manipulation;
        -webkit-user-select: none;
        user-select: none;
    }
    
    .form-input {
        -webkit-appearance: none;
        border-radius: 0;
        -webkit-user-select: text;
        user-select: text;
    }
    
    .form-input:focus {
        outline: none;
        -webkit-appearance: none;
        zoom: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    
    .form-textarea {
        -webkit-appearance: none;
        resize: vertical;
    }
    
    .form-label {
        -webkit-user-select: none;
        user-select: none;
        pointer-events: none;
    }
}

/* Submit Button */
.submit-btn {
    width: 100%;
    padding: 18px 40px;
    background: linear-gradient(135deg, #ED2775 0%, #FF7448 100%);
    border: none;
    border-radius: 50px;
    color: white;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(237, 39, 117, 0.3);
}

.submit-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(237, 39, 117, 0.4);
}

.submit-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.btn-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-content i {
    font-size: 18px;
}

/* Background Elements */
.background-elements {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden;
}

.gradient-orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(40px);
    opacity: 0.3;
    animation: orbFloat 8s ease-in-out infinite;
}

.orb-1 {
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, #ED2775 0%, transparent 70%);
    top: -150px;
    left: -150px;
    animation-delay: 0s;
}

.orb-2 {
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, #60a5fa 0%, transparent 70%);
    top: 50%;
    right: -100px;
    animation-delay: 4s;
}

.orb-3 {
    width: 250px;
    height: 250px;
    background: radial-gradient(circle, #f472b6 0%, transparent 70%);
    bottom: -125px;
    left: 50%;
    animation-delay: 8s;
}

.mesh-grid {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
        linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px);
    background-size: 50px 50px;
    animation: gridMove 30s linear infinite;
}

/* Map Section */
.map-section {
    position: relative;
    height: 500px;
    overflow: hidden;
}

.map-container {
    position: relative;
    width: 100%;
    height: 100%;
}

.map-container iframe {
    width: 100%;
    height: 100%;
    border: none;
    filter: grayscale(30%) contrast(1.2);
    transition: filter 0.3s ease;
    max-width: 100%;
    display: block;
}

.map-container:hover iframe {
    filter: grayscale(0%) contrast(1);
}

.map-overlay {
    position: absolute;
    top: 30px;
    left: 30px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    padding: 25px;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    max-width: 300px;
}

.location-info h3 {
    color: #1a1a2e;
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 10px;
}

.location-info p {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
}

/* Animations */
@keyframes slideIn {
    to {
        transform: translateX(0);
    }
}

@keyframes floatAnimation {
    0%, 100% {
        transform: translateY(0px) rotate(0deg);
    }
    50% {
        transform: translateY(-20px) rotate(180deg);
    }
}

@keyframes orbFloat {
    0%, 100% {
        transform: translate(0, 0) scale(1);
    }
    33% {
        transform: translate(30px, -30px) scale(1.1);
    }
    66% {
        transform: translate(-20px, 20px) scale(0.9);
    }
}

@keyframes gridMove {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(50px, 50px);
    }
}

@keyframes spinning {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@keyframes iconFloat {
    0%, 100% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(-15px);
    }
}

.spinning {
    animation: spinning 1s linear infinite;
}

/* Responsive Design */
@media (max-width: 991px) {
    .contact-form-container {
        max-width: 100%;
        padding: 0 20px;
    }
    
    .form-wrapper {
        margin: 0;
        padding: 35px 25px;
    }
}

@media (max-width: 768px) {
    .contact-section {
        padding: 50px 0;
        min-height: auto;
    }
    
    .simple-header {
        padding: 20px 0;
        margin-bottom: 40px;
    }
    
    .hero-main-title {
        font-size: 3.2rem;
        letter-spacing: -1px;
        margin-bottom: 25px;
    }
    
    .hero-description {
        font-size: 1.1rem;
        padding: 0 20px;
        margin: 0 auto;
    }
    
    .sub-title {
        font-size: 16px;
        margin-bottom: 20px;
    }
    
    .contact-form-container {
        padding: 0 15px;
        margin-bottom: 40px;
    }
    
    .form-wrapper {
        padding: 30px 20px;
        border-radius: 20px;
        margin: 0;
    }
    
    /* Mobile Form Enhancements */
    .modern-contact-form {
        width: 100%;
        overflow: hidden;
    }
    
    .form-grid {
        grid-template-columns: 1fr;
        gap: 25px;
        width: 100%;
    }
    
    .form-group {
        width: 100%;
        box-sizing: border-box;
    }
    
    .input-wrapper {
        width: 100%;
        position: relative;
        display: block;
    }
    
    .form-input {
        font-size: 16px; /* Prevents zoom on iOS */
        padding: 18px 0 10px 0;
        width: 100%;
        box-sizing: border-box;
        display: block;
        -webkit-text-size-adjust: 100%;
    }
    
    .form-label {
        font-size: 15px;
        top: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 80%;
    }
    
    .form-textarea {
        min-height: 120px;
        resize: vertical;
        overflow-y: auto;
    }
    
    .submit-btn {
        padding: 16px 30px;
        font-size: 16px;
        margin-top: 10px;
        min-height: 56px; /* Better touch target */
        width: 100%;
        box-sizing: border-box;
        border: none;
        cursor: pointer;
    }
    
    .btn-content i {
        font-size: 16px;
    }
    
    .message-toast {
        right: 15px;
        left: 15px;
        max-width: none;
        top: 20px;
    }
    
    .map-section {
        height: 400px;
    }
    
    .map-overlay {
        top: 20px;
        left: 20px;
        right: 20px;
        max-width: none;
        padding: 20px;
    }
    
    /* Hide background decorations */
    .floating-shape {
        display: none;
    }
    
    .gradient-orb {
        opacity: 0.15;
    }
}

@media (max-width: 767px) {
    .simple-header {
        padding: 40px 0 10px    ;
        margin-bottom: 30px;
    }
     .contact-section {
        padding: 40px 0 0px;
    }
    .hero-main-title {
        font-size: 2.5rem;
        letter-spacing: 0;
        margin-bottom: 20px;
        line-height: 1.2;
    }
    
    .hero-description {
        font-size: 13px;
        padding: 0 15px;
        line-height: 1.6;
    }
    
    .sub-title {
        font-size: 14px;
        letter-spacing: 1px;
        margin-bottom: 15px;
    }
    
    .contact-form-container {
        padding: 0 10px;
    }
    
    .form-wrapper {
        padding: 25px 18px;
        border-radius: 18px;
    }
    
    /* Enhanced Mobile Form Styling */
    .modern-contact-form {
        width: 100%;
        max-width: 100%;
        overflow: visible;
        padding: 0;
        margin: 0;
    }
    
    .form-grid {
        gap: 22px;
        display: flex;
        flex-direction: column;
        width: 100%;
        margin: 0;
        padding: 0;
    }
    
    .form-group {
        width: 100%;
        margin: 0;
        padding: 0;
        flex-shrink: 0;
    }
    
    .form-group.full-width {
        width: 100%;
    }
    
    .input-wrapper {
        width: 100%;
        position: relative;
        margin: 0;
        padding: 0;
    }
    
    .form-input {
        font-size: 16px; /* Prevents iOS zoom */
        padding: 16px 0 8px 0;
        width: 100%;
        max-width: 100%;
        border: none;
        border-bottom: 2px solid #101720;
        background: transparent;
        color: #ffffff;
        box-sizing: border-box;
        display: block;
        margin: 0;
        -webkit-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased;
    }
    
    .form-label {
        font-size: 14px;
        top: 16px;
        left: 0;
        /* color: rgba(255, 255, 255, 0.7); */
        pointer-events: none;
        transition: all 0.3s ease;
        transform-origin: left top;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 90%;
    }
    
    .form-input:focus + .form-label,
    .form-input:not(:placeholder-shown) + .form-label {
        transform: translateY(-18px) scale(0.85);
        /* color: #fff; */
        font-weight: 600;
    }
    
    .form-textarea {
        min-height: 100px;
        padding-top: 16px;
        resize: vertical;
        font-family: inherit;
        line-height: 1.5;
    }
    
    .textarea-wrapper .form-label {
        top: 16px;
    }
    
    .submit-btn {
        padding: 15px 25px;
        font-size: 15px;
        margin-top: 15px;
        min-height: 52px;
        border-radius: 26px;
        width: 100%;
        box-sizing: border-box;
        border: none;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        touch-action: manipulation;
    }
    
    .btn-content {
        gap: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .btn-content i {
        font-size: 15px;
        flex-shrink: 0;
    }
    
    .recaptcha-container {
        margin: 15px 0;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .map-section {
        height: 350px;
    }
    
    .map-overlay {
        padding: 18px;
        border-radius: 12px;
    }
    
    .location-info h3 {
        font-size: 1.1rem;
        margin-bottom: 8px;
    }
    
    .location-info p {
        font-size: 13px;
    }
    
    /* Hide all background effects on small screens */
    .orb-1, .orb-2, .orb-3 {
        display: none;
    }
    
    .mesh-grid {
        opacity: 0.5;
    }
}

@media (max-width: 375px) {
    .hero-main-title {
        font-size: 2.2rem;
    }
    
    .contact-form-container {
        padding: 0 8px;
    }
    
    .form-wrapper {
        padding: 20px 15px;
        border-radius: 16px;
    }
    
    /* Ultra Mobile Form Optimization */
    .modern-contact-form {
        width: 100%;
        max-width: 100%;
        padding: 0;
        margin: 0;
    }
    
    .form-grid {
        gap: 20px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    
    .form-group {
        width: 100%;
        margin: 0;
    }
    
    .input-wrapper {
        width: 100%;
        margin: 0;
        padding: 0;
    }
    
    .form-input {
        font-size: 16px; /* Critical for iOS */
        padding: 14px 0 6px 0;
        width: 100%;
        border: none;
        border-bottom: 2px solid rgba(255, 255, 255, 0.2);
        background: transparent;
        color: #ffffff;
        box-sizing: border-box;
        margin: 0;
    }
    
    .form-label {
        font-size: 13px;
        top: 14px;
        max-width: 85%;
    }
    
    .form-input:focus + .form-label,
    .form-input:not(:placeholder-shown) + .form-label {
        transform: translateY(-16px) scale(0.85);
    }
    
    .form-textarea {
        min-height: 90px;
        padding-top: 14px;
        line-height: 1.4;
    }
    
    .textarea-wrapper .form-label {
        top: 14px;
    }
    
    .submit-btn {
        padding: 14px 20px;
        min-height: 50px;
        font-size: 14px;
        width: 100%;
        margin-top: 20px;
        border-radius: 25px;
    }
    
    .btn-content {
        gap: 6px;
    }
    
    .btn-content i {
        font-size: 14px;
    }
    
    .recaptcha-container {
        margin: 12px 0;
        width: 100%;
    }
    
    .map-overlay {
        top: 15px;
        left: 15px;
        right: 15px;
        padding: 15px;
    }
}

/* Extra small devices (320px and below) */
@media (max-width: 320px) {
    .modern-contact-form {
        width: 100%;
        padding: 0;
    }
    
    .form-wrapper {
        padding: 18px 12px;
        border-radius: 14px;
    }
    
    .form-input {
        font-size: 16px; /* Still 16px for iOS */
        padding: 12px 0 4px 0;
    }
    
    .form-label {
        font-size: 12px;
        top: 12px;
    }
    
    .form-input:focus + .form-label,
    .form-input:not(:placeholder-shown) + .form-label {
        transform: translateY(-14px) scale(0.9);
    }
    
    .submit-btn {
        padding: 12px 16px;
        min-height: 48px;
        font-size: 13px;
    }
}

/* Landscape orientation fixes for mobile */
@media (max-height: 600px) and (orientation: landscape) {
    .contact-section {
        min-height: auto;
        padding: 30px 0;
    }
    
    .simple-header {
        padding: 15px 0;
        margin-bottom: 25px;
    }
    
    .hero-main-title {
        font-size: 2.5rem;
        margin-bottom: 15px;
    }
    
    .hero-description {
        font-size: 0.95rem;
        margin-bottom: 0;
    }
    
    .modern-contact-form {
        padding: 0;
    }
    
    .form-wrapper {
        padding: 20px 15px;
    }
    
    .form-grid {
        gap: 18px;
    }
}

/* High DPI / Retina Display Optimization */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    .modern-contact-form .form-input {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    
    .submit-btn {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
}
</style>

<script>
import axios from 'axios';
 import recaptcha from './recaptcha2.vue'
import { ref } from 'vue'
 
export default {
  name: 'Contact',
  components: {
    recaptcha
  },
  data() {
    return {
      recaptchaDiv: ref(null),
      recaptcha: null,
      isSubmitting: false,
      formData: {
        title: '',
        name: '',
        email: '',
        phone: '',
        admin_notes: '',
        notes: '',
        showRecaptcha: true,
        loadingTimeout: 30000,
        technology: ["6411a6e851836b26af966e3a"],
        lead_status: "63e396de2052e0098e18deec",
        lead_stage: "63e391a22052e0098e18de7f",
        source: "63ef454c5fb91668b7f123d1",
        channelId: "652ce6c89d423da8d2ab52c3",
        type: '63e39dd62052e0098e18e015',
        outsource: "63ef454c5fb91668b7f123d1",
    },
      newsletterEmail: '',
    successMessage: null,
   failMessage: null,
    };
  },
  methods: {
    async submitForm() {
      this.isSubmitting = true;
      this.formData.title = this.formData.name;
      
      try {
        await axios.post('https://do.meander.software:5000/api/outsourcingLeads/add', this.formData);
        
        this.successMessage = 'Message sent successfully! We\'ll get back to you soon.';
        
            // Reset form fields after successful submission
            this.formData.name = '';
            this.formData.email = '';
            this.formData.phone = '';
            this.formData.admin_notes = '';
            this.formData.notes = '';
        
        // Auto hide success message after 5 seconds
        setTimeout(() => {
          this.successMessage = null;
        }, 5000);
        
      } catch (error) {
            console.error('API Error:', error);
        this.failMessage = 'Sorry, something went wrong. Please try again.';
        
        // Auto hide error message after 5 seconds
        setTimeout(() => {
          this.failMessage = null;
        }, 5000);
      } finally {
        this.isSubmitting = false;
      }
    },
    
    closeMessage() {
      this.successMessage = null;
      this.failMessage = null;
    }
  },
  
  created() {
    this.formData.email = localStorage.getItem("email") || '';
  },
  
  mounted() {
    // Initialize AOS (Animate On Scroll) if available
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  }
}
</script>